import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { PatientClient } from "../../services/patient.client";
import { PayorService } from "../../services/payor.service";
import { EmptyData} from "../../constants/core-constants";
import { formatDateOnly } from "../../utils/date-only.util";

@Component({
  selector: "app-patient-header",
  templateUrl: "./patient-header.component.html",
  styleUrls: ["./patient-header.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class PatientHeaderComponent implements OnInit {
  @Input() patient: any;
  private destroy$ = new Subject<void>();
  headerData: any;
  
  constructor(
    private patientClient: PatientClient,
    private payorService: PayorService
  ) {}

  async ngOnInit() {
    // await this.getPayorHeaderInfo();
    this.payorService.payorChange$
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.getPayorHeaderInfo();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getPayorHeaderInfo() {
    this.headerData = await firstValueFrom(
      this.patientClient.getHeaderInfo(this.patient?.id as string)
    );
  }
  /**
   * getDateFormat
   */
  public getDateFormat(value: string) {
    if (!value || value === EmptyData) {
      return value;
    }
    else if(value?.includes(' - ')){
      const splitDates = value.split(' - ')
      return `${formatDateOnly(splitDates[0], "MMM dd, yyyy")} - ${formatDateOnly(splitDates[1], "MMM dd, yyyy")}`
    }
    return formatDateOnly(value, "MMM dd, yyyy");
  }
}
